var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultPasskeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 684,
    viewBox: "0 0 486 684",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.217 287.435C459.718 288.926 485.648 315.785 485.648 348.651V622.526C485.648 656.349 458.188 683.808 424.366 683.808H61.3714C27.5494 683.808 0.0898438 656.349 0.0898438 622.526V348.651C0.0898438 316.372 25.1007 289.888 56.7839 287.539V185.525C56.7839 83.3013 139.778 0.308594 242.001 0.308594C344.225 0.308594 427.217 83.3013 427.217 185.525V287.435ZM141.981 284.741L342.05 285.872C342.05 285.872 342.499 180.619 342.444 179.986C337.292 120.636 285.413 85.1351 242.001 85.5838C200.705 86.0107 144.531 114.671 142.304 179.305C142.127 184.441 141.981 284.741 141.981 284.741ZM210.818 504.544L200.13 573.483C200.13 573.483 198.107 587.089 200.114 591.398C204.407 600.613 211.335 599.708 211.335 599.708L272.114 599.44C272.114 599.44 279.26 600.063 283.956 590.897C286.163 586.588 283.647 572.78 283.647 572.78L273.146 504.562C296.85 493 313.198 468.659 313.198 440.532C313.198 401.237 281.295 369.334 242.001 369.334C202.706 369.334 170.803 401.237 170.803 440.532C170.803 468.645 187.134 492.974 210.818 504.544Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPasskeyIcon);
export default __webpack_public_path__ + "static/media/DefaultPasskeyIcon.42c99ff1c722eee1c8e3e19a4e696ec9.svg";
export { ForwardRef as ReactComponent };